"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var injectStyleProp_1 = require("../utils/injectStyleProp");
var FontWeightEnum_1 = require("../enums/FontWeightEnum");
var TextAlignmentEnum_1 = require("../enums/TextAlignmentEnum");
var TextCaseEnum_1 = require("../enums/TextCaseEnum");
var DefaultAtomValues_1 = require("../constants/DefaultAtomValues");
var defaultProps = {
    onPress: undefined,
    multilineLimit: undefined,
    fontFamily: undefined,
    fontSize: 12,
    fontWeight: FontWeightEnum_1.FontWeightEnum.normal,
    lineHeight: undefined,
    opacity: 1,
    textAlign: TextAlignmentEnum_1.TextAlignmentEnum.left,
    textCase: TextCaseEnum_1.TextCaseEnum.none,
    textColor: DefaultAtomValues_1.DefaultAtomColors.gray,
    textColorReadMore: DefaultAtomValues_1.DefaultAtomColors.black
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
var BaseText = native_1.default(react_native_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\ttext-transform: ", ";\n"], ["\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\ttext-transform: ", ";\n"
    // The content text shown by the ATLAtomLabel
])), function (props) { return props.fontFamily && "font-family: " + props.fontFamily; }, injectStyleProp_1.injectStyleProp('font-size'), injectStyleProp_1.injectStyleProp('font-weight'), injectStyleProp_1.injectStyleProp('line-height'), injectStyleProp_1.injectStyleProp('text-align'), injectStyleProp_1.injectStyleProp('opacity'), function (props) { return props.textCase; });
// The content text shown by the ATLAtomLabel
var BodyText = native_1.default(BaseText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcolor: ", ";\n"], ["\n\tcolor: ", ";\n"
    // If the read more option is enabled, show a text button with this style
])), function (props) { return props.textColor; });
// If the read more option is enabled, show a text button with this style
var ReadMoreText = native_1.default(BaseText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: ", ";\n"], ["\n\tcolor: ", ";\n"
    // Invisible view to hide full text from user when it needs to be rendered
])), function (props) { return props.textColorReadMore; });
// Invisible view to hide full text from user when it needs to be rendered
var FullTextView = native_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])));
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLAtomLabel = function (_a) {
    var children = _a.children, readMoreText = _a.readMoreText, onPress = _a.onPress, multilineLimit = _a.multilineLimit, readMoreLimit = _a.readMoreLimit, fontFamily = _a.fontFamily, fontSize = _a.fontSize, fontWeight = _a.fontWeight, lineHeight = _a.lineHeight, opacity = _a.opacity, textAlign = _a.textAlign, textCase = _a.textCase, textColor = _a.textColor, textColorReadMore = _a.textColorReadMore;
    var _b = react_1.useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var _c = react_1.useState(false), shouldShowReadMore = _c[0], setShouldShowReadMore = _c[1];
    var _d = react_1.useState(0), fullTextHeight = _d[0], setFullTextHeight = _d[1];
    var _e = react_1.useState(0), trimTextHeight = _e[0], setTrimTextHeight = _e[1];
    var currentFullHeight = react_1.useRef(fullTextHeight);
    var currentTrimHeight = react_1.useRef(trimTextHeight);
    // Changes between expanded and not expanded text for read more/less function
    var toggleExpansion = react_1.useCallback(function () {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);
    // Gets the height of the full text view
    var onLayoutFullText = function (event) {
        if (currentFullHeight.current === 0) {
            var height = event.nativeEvent.layout.height;
            setFullTextHeight(height);
        }
    };
    // Gets the height of the collapsed text view
    var onLayoutTrimText = function (event) {
        if (currentTrimHeight.current === 0) {
            var height = event.nativeEvent.layout.height;
            setTrimTextHeight(height);
        }
    };
    // Decides if the read more button should be shown
    var shouldShowButton = function () {
        if (fullTextHeight > trimTextHeight && readMoreLimit) {
            setShouldShowReadMore(true);
        }
        else {
            setShouldShowReadMore(false);
        }
    };
    // When there is a read more limit, this function will get the view heights after they have been rendered
    // to decide whether os not the read more button should be shown
    react_1.useEffect(function () {
        if (readMoreLimit) {
            if (fullTextHeight !== 0 && trimTextHeight !== 0) {
                shouldShowButton();
                currentTrimHeight.current = trimTextHeight;
                currentFullHeight.current = fullTextHeight;
            }
        }
    }, [trimTextHeight, fullTextHeight]);
    // React Native doesn't yet have a method to return the number of lines that a text has, so in order to know if the
    // read more button should be rendered, we have to render the full text to see its view height. It will be hidden
    // from the user by a view previously created (FullTextView).
    var renderFullText = function () { return (react_1.default.createElement(BodyText, { fontFamily: fontFamily, fontSize: fontSize, fontWeight: fontWeight, lineHeight: lineHeight, opacity: opacity, textAlign: textAlign, textCase: textCase, textColor: textColor, onLayout: readMoreLimit && onLayoutFullText }, children)); };
    // Renders the content text
    var renderText = function () { return (react_1.default.createElement(BodyText, { onPress: onPress, numberOfLines: isExpanded || readMoreLimit === undefined ? multilineLimit : readMoreLimit, fontFamily: fontFamily, fontSize: fontSize, fontWeight: fontWeight, lineHeight: lineHeight, opacity: opacity, textAlign: textAlign, textCase: textCase, textColor: textColor, onLayout: readMoreLimit && onLayoutTrimText }, children)); };
    // Renders see more/less button
    var renderReadMoreText = function () { return (react_1.default.createElement(ReadMoreText, { onPress: toggleExpansion, fontFamily: fontFamily, fontSize: fontSize, fontWeight: fontWeight, lineHeight: lineHeight, opacity: opacity, textAlign: textAlign, textCase: textCase, textColorReadMore: textColorReadMore }, readMoreText)); };
    // Returns complete ATLAtomLabel
    if (readMoreLimit) {
        return (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: { zIndex: 99 } },
                renderText(),
                shouldShowReadMore && !isExpanded && renderReadMoreText()),
            react_1.default.createElement(FullTextView, null, renderFullText())));
    }
    else
        return renderText();
};
exports.ATLAtomLabel.defaultProps = defaultProps;
exports.ATLAtomLabel.displayName = 'ATLAtomLabel';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
